'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MsaOfferProduct = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _reactRouterRedux = require('react-router-redux');

var _reduxForm = require('redux-form');

var _sagaTools = require('@classpass/saga-tools');

var _effects = require('redux-saga/effects');

var _bound = require('redux/saga/entities/bound');

var _selectors = require('redux/saga/selectors');

var _Authentication = require('features/Login/Authentication.saga');

var _FormAction = require('features/Signup/FormAction');

var _msas = require('constants/msas');

var _multitrack = require('helpers/multitrack');

var _corporate = require('helpers/corporate');

var _GoogleTagManager = require('components/GoogleTagManager/GoogleTagManager');

var _cart = require('redux/modules/cart');

var _BaseProduct2 = require('./BaseProduct');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var REFERRAL_PROMOTION_ALIASES = ['referafriend', 'referral-trial'];

var MsaOfferProduct = exports.MsaOfferProduct = function (_BaseProduct) {
  (0, _inherits3.default)(MsaOfferProduct, _BaseProduct);

  function MsaOfferProduct() {
    (0, _classCallCheck3.default)(this, MsaOfferProduct);
    return (0, _possibleConstructorReturn3.default)(this, (MsaOfferProduct.__proto__ || (0, _getPrototypeOf2.default)(MsaOfferProduct)).apply(this, arguments));
  }

  (0, _createClass3.default)(MsaOfferProduct, null, [{
    key: 'loadOffer',
    value: /*#__PURE__*/_regenerator2.default.mark(function loadOffer(client, msaOfferId) {
      return _regenerator2.default.wrap(function loadOffer$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return (0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.msaOfferById, [client, msaOfferId]);

            case 3:
              return _context.abrupt('return', _context.sent);

            case 6:
              _context.prev = 6;
              _context.t0 = _context['catch'](0);

              if (!(_context.t0.code === 404)) {
                _context.next = 12;
                break;
              }

              _context.next = 11;
              return (0, _effects.put)((0, _reactRouterRedux.replace)('/'));

            case 11:
              return _context.abrupt('return');

            case 12:
              throw _context.t0;

            case 13:
            case 'end':
              return _context.stop();
          }
        }
      }, loadOffer, this, [[0, 6]]);
    })
  }, {
    key: 'loadSignupData',
    value: /*#__PURE__*/_regenerator2.default.mark(function loadSignupData(client) {
      var _ref, msaOfferId, msaOffer, msaId;

      return _regenerator2.default.wrap(function loadSignupData$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return (0, _effects.call)(MsaOfferProduct.getProductData);

            case 2:
              _ref = _context2.sent;
              msaOfferId = _ref.msaOfferId;
              _context2.next = 6;
              return (0, _effects.call)(MsaOfferProduct.loadOffer, client, msaOfferId);

            case 6:
              msaOffer = _context2.sent;

              if (!msaOffer) {
                _context2.next = 13;
                break;
              }

              msaId = msaOffer.msa.id;
              _context2.next = 11;
              return (0, _effects.spawn)(_GoogleTagManager.trackGoogleTagManagerEvent, {
                msaId: msaId,
                msaName: (0, _msas.msaIdToAlias)(msaId)
              });

            case 11:
              _context2.next = 13;
              return (0, _effects.put)((0, _reduxForm.change)('signup', 'msaOfferId', msaOfferId));

            case 13:
            case 'end':
              return _context2.stop();
          }
        }
      }, loadSignupData, this);
    })
  }, {
    key: 'submitSignupData',
    value: /*#__PURE__*/_regenerator2.default.mark(function submitSignupData(client, basePayload) {
      var _ref2, msaOfferId;

      return _regenerator2.default.wrap(function submitSignupData$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return (0, _effects.call)(MsaOfferProduct.getProductData);

            case 2:
              _ref2 = _context3.sent;
              msaOfferId = _ref2.msaOfferId;
              _context3.next = 6;
              return (0, _effects.call)(_Authentication.createUserAndLogIn, client, _FormAction.signup, (0, _extends3.default)({}, basePayload, {
                msa_offer_id: msaOfferId
              }));

            case 6:
              return _context3.abrupt('return', _context3.sent);

            case 7:
            case 'end':
              return _context3.stop();
          }
        }
      }, submitSignupData, this);
    })
  }, {
    key: 'loadPurchaseData',
    value: /*#__PURE__*/_regenerator2.default.mark(function loadPurchaseData(client) {
      var _ref3, msaOfferId, msaOffer, referAFriendCode, corporateDetails;

      return _regenerator2.default.wrap(function loadPurchaseData$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return (0, _effects.call)(MsaOfferProduct.getProductData);

            case 2:
              _ref3 = _context4.sent;
              msaOfferId = _ref3.msaOfferId;
              _context4.next = 6;
              return (0, _effects.call)(MsaOfferProduct.loadOffer, client, msaOfferId);

            case 6:
              msaOffer = _context4.sent;

              if (!msaOffer) {
                _context4.next = 23;
                break;
              }

              if (!REFERRAL_PROMOTION_ALIASES.includes(msaOffer.promotion.alias)) {
                _context4.next = 14;
                break;
              }

              _context4.next = 11;
              return (0, _effects.select)(_selectors.friendbuyCode);

            case 11:
              _context4.t0 = _context4.sent;
              _context4.next = 15;
              break;

            case 14:
              _context4.t0 = '';

            case 15:
              referAFriendCode = _context4.t0;
              _context4.next = 18;
              return (0, _effects.call)(_corporate.getCorporateDetails, msaOffer.initial_plan.plan_code);

            case 18:
              corporateDetails = _context4.sent;
              _context4.next = 21;
              return (0, _effects.all)([(0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.planById, [client, msaOffer.initial_plan.id]), (0, _effects.put)((0, _reduxForm.change)('purchase', 'msaOfferId', msaOfferId)), (0, _effects.put)((0, _reduxForm.change)('purchase', 'msaId', msaOffer.msa.id)), (0, _effects.put)((0, _reduxForm.change)('purchase', 'planId', msaOffer.initial_plan.id)), (0, _effects.put)((0, _reduxForm.change)('purchase', 'friendbuyCode', referAFriendCode)), (0, _effects.put)((0, _reduxForm.change)('purchase', 'corporateDetails', corporateDetails))]);

            case 21:
              _context4.next = 23;
              return (0, _effects.all)([(0, _effects.put)((0, _cart.emptyCart)()), (0, _effects.put)((0, _cart.addCartItem)('plan', msaOffer.content.purchase_info.charge_name, msaOffer.price, {
                planCode: msaOffer.initial_plan.plan_code
              }))]);

            case 23:
            case 'end':
              return _context4.stop();
          }
        }
      }, loadPurchaseData, this);
    })
  }, {
    key: 'trackPurchaseFailure',
    value: /*#__PURE__*/_regenerator2.default.mark(function trackPurchaseFailure() {
      var _ref4, msaOfferId;

      return _regenerator2.default.wrap(function trackPurchaseFailure$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return (0, _effects.call)(MsaOfferProduct.getProductData);

            case 2:
              _ref4 = _context5.sent;
              msaOfferId = _ref4.msaOfferId;
              _context5.next = 6;
              return (0, _effects.spawn)(_multitrack.ga, 'Membership Purchase', 'Membership Purchase Errors', 'offer-' + msaOfferId);

            case 6:
            case 'end':
              return _context5.stop();
          }
        }
      }, trackPurchaseFailure, this);
    })
  }, {
    key: 'trackPurchaseSuccess',
    value: /*#__PURE__*/_regenerator2.default.mark(function trackPurchaseSuccess(result) {
      var _ref5, msaOfferId;

      return _regenerator2.default.wrap(function trackPurchaseSuccess$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return (0, _effects.call)(MsaOfferProduct.getProductData);

            case 2:
              _ref5 = _context6.sent;
              msaOfferId = _ref5.msaOfferId;
              _context6.next = 6;
              return (0, _effects.call)(_BaseProduct2.BaseProduct.trackPurchaseSuccess, result);

            case 6:
              _context6.next = 8;
              return (0, _effects.spawn)(_multitrack.ga, 'Membership Purchase', 'Checkout Success', 'offer-' + msaOfferId);

            case 8:
            case 'end':
              return _context6.stop();
          }
        }
      }, trackPurchaseSuccess, this);
    })
  }, {
    key: 'trackSignupFailure',
    value: /*#__PURE__*/_regenerator2.default.mark(function trackSignupFailure() {
      var _ref6, msaOfferId;

      return _regenerator2.default.wrap(function trackSignupFailure$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return (0, _effects.call)(MsaOfferProduct.getProductData);

            case 2:
              _ref6 = _context7.sent;
              msaOfferId = _ref6.msaOfferId;
              _context7.next = 6;
              return (0, _effects.spawn)(_multitrack.ga, 'Membership Purchase', 'Create Account Error', 'offer-' + msaOfferId);

            case 6:
            case 'end':
              return _context7.stop();
          }
        }
      }, trackSignupFailure, this);
    })
  }, {
    key: 'trackSignupSuccess',
    value: /*#__PURE__*/_regenerator2.default.mark(function trackSignupSuccess() {
      var _ref7, msaOfferId;

      return _regenerator2.default.wrap(function trackSignupSuccess$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return (0, _effects.call)(MsaOfferProduct.getProductData);

            case 2:
              _ref7 = _context8.sent;
              msaOfferId = _ref7.msaOfferId;
              _context8.next = 6;
              return (0, _effects.spawn)(_multitrack.ga, 'Membership Purchase', 'Membership Account Creation', 'offer-' + msaOfferId);

            case 6:
            case 'end':
              return _context8.stop();
          }
        }
      }, trackSignupSuccess, this);
    })
  }]);
  return MsaOfferProduct;
}(_BaseProduct2.BaseProduct);

MsaOfferProduct.key = 'MsaOfferProduct';